<template>
  <GraphqlDataTableFilter v-if="arg !== undefined" v-model="model" :arg />
  <WdsText v-else-if="!loading" error :text="$t('Filter not found')" />
</template>

<script lang="ts" setup>
import { watch } from 'vue'
import { WdsText } from '@worksome/wds-components'
import { $t } from '@/app-bootstrapping/SetUpInternationalization'
import { useQueryArg } from '@/components/GraphqlDataTable/composables'
import GraphqlDataTableFilter from '@/components/GraphqlDataTable/filters/GraphqlDataTableFilter.vue'

const props = defineProps<{
  argumentString: string
  query: string
}>()

const model = defineModel<any>()

const { arg, loading } = useQueryArg(props.query, props.argumentString)
watch(arg, () => {
  if (arg.value) {
    arg.value.filter.quickFilter = true
  }
})
</script>

<style lang="scss" scoped></style>
